import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaBuilding, FaExclamationTriangle } from 'react-icons/fa';
import SEO from '../components/SEO';

function NotFound() {
  return (
    <>
      <SEO
        title="Página não encontrada - 404"
        description="A página que você está procurando não foi encontrada."
        robots="noindex,nofollow"
        pageType="website"
      />
      
      <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="max-w-md w-full space-y-8 text-center">
          {/* Ícone de erro */}
          <div className="mx-auto h-32 w-32 text-red-400 flex items-center justify-center">
            <FaExclamationTriangle className="h-full w-full" />
          </div>

          {/* Título principal */}
          <div>
            <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">
              Página não encontrada
            </h2>
            <p className="text-gray-600 text-lg">
              Desculpe, a página que você está procurando não existe ou foi movida.
            </p>
          </div>

          {/* Botões de ação */}
          <div className="space-y-4">
            <Link
              to="/"
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              <FaHome className="w-5 h-5 mr-2" />
              Voltar ao Início
            </Link>
            
            <Link
              to="/propriedades"
              className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              <FaBuilding className="w-5 h-5 mr-2" />
              Ver Propriedades
            </Link>
          </div>

          {/* Informações adicionais */}
          <div className="pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Se você acredita que isso é um erro, entre em contato conosco.
            </p>
            <Link
              to="/contato"
              className="text-blue-600 hover:text-blue-500 text-sm font-medium transition-colors duration-200"
            >
              Página de Contato
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
